import type { FastifyInstance } from 'fastify'
import { searchRoutes } from './search.routes.js'

export default async function searchModule(app: FastifyInstance) {
  await app.register(searchRoutes)
}
